import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['Guía completa de alimentación natural', 'Alimentos permitidos y prohibidos', 'Cálculo de porciones según su peso', 'Cómo armar comidas balanceadas', 'Cómo hacer la transición del balanceado a lo natural', 'Recetas simples y fáciles', 'Ejemplo de plan semanal listo para usar'];
export function ProductBreakdown() {
  return <section className="py-20 px-4 bg-cream" data-id="element-232">
      <div className="max-w-4xl mx-auto" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-235">
            Dentro de Nutrición Canina Fácil vas a encontrar:
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full" data-id="element-236"></div>
        </motion.div>

        <div className="bg-white rounded-3xl shadow-soft p-8 md:p-12 border border-sage" data-id="element-237">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-238">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start" data-id="element-239">
                <div className="mt-1 bg-sage rounded-full p-1 flex-shrink-0 mr-4" data-id="element-240">
                  <CheckIcon className="w-5 h-5 text-primary" data-id="element-241" />
                </div>
                <span className="text-lg text-gray-700 font-medium" data-id="element-242">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}